import React, { useState, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export default function Example({ show, handleClose, src, videoTrack, transcript, muted, title }) {

  const [showCaptions, setShowCaptions] = useState(false);
  const videoRef = useRef(null);
  const handleVolumeChange = () => {
    const isMuted = videoRef.current.muted;
    setShowCaptions(isMuted);
  };

  const getChromeVersion = () => {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    if (raw) {
      return parseInt(raw[2], 10);
    }
    else {
      return 100;
    }
  }

  const handlePatientIfuPdf = () => {
    var ddg_file = '/pdfs/inbrija-patient-info-IFU.pdf';
    if (window.location.pathname.includes('informacion-en-espanol')) {
      ddg_file = '/pdfs/guia-de-conversacion-con-medicos.pdf';
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const myUrlWithParams = new URL(window.location.protocol + '//' + window.location.hostname + '/pdf-resources');

    myUrlWithParams.searchParams.append('file', ddg_file);
    if (urlParams.get('utm_campaign')) {
      myUrlWithParams.searchParams.append('utm_campaign', urlParams.get('utm_campaign'));
    }
    if (urlParams.get('utm_medium')) {
      myUrlWithParams.searchParams.append('utm_medium', urlParams.get('utm_medium'));
    }
    if (urlParams.get('utm_source')) {
      myUrlWithParams.searchParams.append('utm_source', urlParams.get('utm_source'));
    }
    if (urlParams.get('utm_content')) {
      myUrlWithParams.searchParams.append('utm_content', urlParams.get('utm_content'));
    }
    window.open(myUrlWithParams);
  }

  const ModalwithHash = () => {
    let el = document.querySelector('.modal.show');
    const video = el.querySelector('video');
    video.muted = false;
    let playbackerror = video.play();

    let trackElem = (el.querySelector('track')) ? el.querySelector('track') : null;
    if (playbackerror !== undefined) {
      playbackerror.then(function () {
        // Autoplay started!
        if (trackElem !== null) {
          let track1 = trackElem.track;
          track1.mode = 'hidden';
        }
      }).catch(function (error) {
        if (trackElem !== null) {
          let track = trackElem.track;
          track.mode = 'showing';
        }
        video.muted = true;
        video.play();
      });
    }
  }

  const DisbableClick = () => {
    if (getChromeVersion() < 60) {
      return "disable-link-click"
    }
    else {
      return ""
    }
  }

  let transcriptLink = false;
  if(transcript) {
    transcriptLink = true;
  }

  let vttTrack = false;
  if(videoTrack.length > 0) {
    vttTrack = true;
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} dialogClassName="video-modal" centered onEntered={ModalwithHash}>
        <div className='modal-close'>
          <div className="close-modal" onClick={handleClose}>
            <div className="close-modal-left "></div>
            <div className="close-modal-right"></div>
          </div>
        </div>
        <Modal.Body className='video-modal-alignment'>
          <video controls autoPlay playsInline title={title} muted={muted} ref={videoRef} onVolumeChange={handleVolumeChange} className='video-width'>
            <source src={src} type="video/mp4" />
            { vttTrack ? <track src={videoTrack} kind="captions" srcLang="en" label="English" default /> : "" }
          </video>
          <div className='video-instructions'>
            <a href="https://dailymed.nlm.nih.gov/dailymed/getFile.cfm?setid=a906f8e1-6e1c-480a-8276-c01bc65dd3be&type=pdf" target='_blank' rel="noreferrer" className={DisbableClick()}>
              Please see Full Prescribing Information
            </a>
            { transcriptLink ? <a target='_blank' href={transcript}>Read Transcript</a> : "" }
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
